import { Link } from 'react-router-dom';
import styled from 'styled-components';
import themeData from 'utils/theme/themeData';

const { typography } = themeData;

export const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: max(100vh, 100%);
  width: 87px;
  background-color: ${({ theme }) => theme.colors.white};
  border-right: 2px solid ${({ theme }) => theme.colors.grey003};
`;

export const LogoWrapper = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 56px;
`;

export const Logo = styled.img`
  width: 26px;
`;

export const ItemContainer = styled.div`
  ${({ pushToEnd }) => pushToEnd && 'margin-top: auto;'}
`;

export const ItemLink = styled(Link)`
  text-decoration: none;
`;

export const ItemWrapper = styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 64px;

  ${({ selected, theme }) =>
    selected &&
    `
    color: ${theme.colors.blueMedium};
    box-shadow: inset 3px 0 0 ${theme.colors.blueMedium};
  `}

  &:hover {
    cursor: pointer;
  }

  &:before {
    content: ${({ icon }) => icon};
    font-family: Icomoon;
    font-size: 22px;
    color: ${({ theme }) => theme.colors.grey002};

    ${({ selected, theme }) =>
      selected &&
      `
    color: ${theme.colors.blueMedium};
  `}
  }
`;

export const Item = styled(typography.BodyTextThreeRegularTypography)`
  margin: 0;
  color: ${({ theme }) => theme.colors.grey002};
  ${({ selected, theme }) =>
    selected &&
    `
    color: ${theme.colors.blueMedium};
  `}
`;

export const LogoutBtn = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 64px;

  ${({ selected, theme }) =>
    selected &&
    `
    color: ${theme.colors.grey002};
    box-shadow: inset 3px 0 0 ${theme.colors.grey002};
  `}

  &:hover {
    cursor: pointer;
    color: ${({ theme }) => theme.colors.redMain};
  }

  &:before {
    content: '\\e906';
    font-family: Icomoon;
    font-size: 18px;
    color: ${({ theme }) => theme.colors.grey002};
    padding-right: 5px;
  }
`;
